module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPgogICAgPHBhdGggZD0ibTg0MC0yMzQtODAtODB2LTQ0NkgzMTRsLTgwLTgwaDUyNnEzMyAwIDU2LjUgMjMuNVQ4NDAtNzYwdjUyNlpNNzkyLTU2bC02NC02NEgyMDBxLTMzIDAtNTYuNS0yMy41VDEyMC0yMDB2LTUyOGwtNjQtNjQgNTYtNTYgNzM2IDczNi01NiA1NlpNMjQwLTI4MGwxMjAtMTYwIDkwIDEyMCAzMy00NC0yODMtMjgzdjQ0N2g0NDdsLTgwLTgwSDI0MFptMjk3LTI1N1pNNDI0LTQyNFoiIGZpbGw9IiNGRkZGRkYiLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/missing_image.svg
// module id = 11
// module chunks = 0